<script>
	import { page } from '$app/stores';
	import { lang } from '$lib/translations/footer';
	import insta from '$lib/images/instaf.svg';
	import wk from '$lib/images/wkf.svg';
	import wp from '$lib/images/whatsappf.svg';
	import arrow from '$lib/images/ArrowRight.svg';
	// @ts-ignore
	import ItemCategoryFooter from './ItemCategoryFooter.svelte';
	import { goto } from '$app/navigation';
	import { slide } from 'svelte/transition';
	import DownloadStore from './DownloadStore.svelte';

	let nashcompanies = [
		{
			name: lang[$page.data.host]['onaslink'],
			slug: '/about'
		},
		{
			name: lang[$page.data.host]['dostpaylink'],
			slug: '/delivery'
		},
		{
			name: lang[$page.data.host]['contactlink'],
			slug: '/contacts'
		},
		{
			name: lang[$page.data.host]['publicofert'],
			slug: '/oferts'
		},
		{
			name: lang[$page.data.host]['politic'],
			slug: '/polytics'
		}
	];

	let recvizits = [
		{ name: 'Индивидуальный предприниматель' },
		{ name: 'Дворниченко Дарья Юрьервна' },
		{ name: 'ИНН 550117177855' },
		{ name: 'ОГРН 321508100002191' },
		{ name: 'Банк АО «Тинькофф Банк' }
	];
	function OnPage(link) {
		goto(link);
		OpenMenu = false;
	}
	let OpenCatalog = false;
	let OpenNashCompany = false;
	let OpenSocSety = false;
	let OpenRecvizits = false;
</script>

<div class="lg:block hidden">
	<div class="w-full bg-custom-dark-bg min-h-[20vh] pl-[18%] pt-[43px] pb-[19px] grid grid-cols-4">
		<!-- Catalog -->
		<div>
			<span class="text-sm text-custom-gray2 font-normal"
				>{lang[$page.data.host]['catalogTitile']}</span
			>
			<ul class="pt-[20px]">
				{#each $page.data.manucategories as item}
					<li class="mt-2">
						<a class="text-sm font-normal text-custom-white-bg" href="/{item.slug}">
							{item[`name${$page.data.host}`]}</a
						>
					</li>
				{/each}
			</ul>
		</div>

		<!-- Company -->
		<div>
			<span class="text-sm text-custom-gray2 font-normal"
				>{lang[$page.data.host]['nahcompany']}</span
			>
			<ul class="pt-[20px]">
				{#each nashcompanies as item}
					<li class="mt-2">
						<a class="text-sm font-normal text-custom-white-bg" href={item.slug}> {item.name}</a>
					</li>
				{/each}
			</ul>
		</div>
		<!-- SocSeti-->
		<div>
			<span class="text-sm text-custom-gray2 font-normal">{lang[$page.data.host]['see']}</span>
			<ul class="pt-[20px]">
				<li class="mt-2">
					<a
						class="text-sm font-normal inline-flex text-custom-gray2"
						target="_blank"
						rel="noreferrer"
						href="https://instagram.com/iloveitalianbags?igshid=YmMyMTA2M2Y="
					>
						<img width="12" height="12" src={insta} alt="" />
						<span class="ml-[8px]">Instagram</span></a
					>
				</li>
				<li class="mt-2">
					<a class="text-sm inline-flex font-normal text-custom-gray2" href="#">
						<img width="14" height="14" src={wk} alt="" />

						<span class="ml-[8px]">VK</span></a
					>
				</li>
				<li class="mt-2">
					<a class="text-sm inline-flex font-normal text-custom-gray2" href="#">
						<img width="12" height="12" src={wp} alt="" />
						<span class="ml-[8px]">Whats App</span>
					</a>
				</li>
			</ul>
		</div>

		<!-- Recvizits-->
		<div>
			<span class="text-sm text-custom-gray2 font-normal mb-[20px]"
				>{lang[$page.data.host]['recvizit']}</span
			>
			<ul class="pt-[20px]">
				<li class="mt-2">
					<a
						class="text-sm font-normal inline-flex text-custom-white-bg"
						target="_blank"
						rel="noreferrer"
						href="https://instagram.com/iloveitalianbags?igshid=YmMyMTA2M2Y="
					>
						<span>{lang[$page.data.host]['individual']}</span></a
					>
				</li>
				{#if $page.data.host != 'ARM'}
					<li class="mt-2">
						<a
							class="text-sm font-normal inline-flex text-custom-white-bg"
							target="_blank"
							rel="noreferrer"
							href="https://instagram.com/iloveitalianbags?igshid=YmMyMTA2M2Y="
						>
							<span>Дворниченко Дарья Юрьервна </span></a
						>
					</li>
					<li class="mt-5">
						<a
							class="text-sm font-normal inline-flex text-custom-white-bg"
							target="_blank"
							rel="noreferrer"
							href="https://instagram.com/iloveitalianbags?igshid=YmMyMTA2M2Y="
						>
							<span>{lang[$page.data.host]['inn']} 550117177855</span></a
						>
					</li>
					<li class="mt-2">
						<a
							class="text-sm font-normal inline-flex text-custom-white-bg"
							target="_blank"
							rel="noreferrer"
							href="https://instagram.com/iloveitalianbags?igshid=YmMyMTA2M2Y="
						>
							<span>{lang[$page.data.host]['ogrn']} 321508100002191</span></a
						>
					</li>
					<li class="mt-2">
						<a
							class="text-sm font-normal inline-flex text-custom-white-bg"
							target="_blank"
							rel="noreferrer"
							href="https://instagram.com/iloveitalianbags?igshid=YmMyMTA2M2Y="
						>
							<span>{lang[$page.data.host]['bank']} АО «Тинькофф Банк</span></a
						>
					</li>
				{:else}
					<p class="mt-4 text-white mb-4">
						Բոլոր գործարքներն իրականացվում են բացառապես 3D Secure համակարգի միջոցով: Գործարք կատարող
						քարտապանի քարտի տվյալները պաշտպանված են: Եթե Քարտապանի Քարտի արժույթը չի համապատասխանում
						գործարքի արժույթի հետ, փոխարկումը իրականացվում է համաձայն համապատասխան վճարահաշվարկային
						համակարգի և Քարտը թողարկող Բանկի կողմից սահմանված կանոնների
					</p>

					<img src="/visa.png" alt="" />
				{/if}
			</ul>
		</div>
		<div class="col-span-12 pt-[80px]">
			<span class="text-custom-gray2 text-sm"
				>Iloveitalianbags. {lang[$page.data.host]['title']}(c) 2021- {new Date().getFullYear()}</span
			>
		</div>
	</div>
</div>

<!-- Mobile footer -->
<div class="lg:hidden md:pb-0 pb-10 mb-10">
	<div class=" w-full bg-custom-dark-bg top-0 z-10 h-max">
		<!-- Каталог -->
		<!-- svelte-ignore a11y-click-events-have-key-events -->
		<div
			on:click={() => {
				OpenCatalog = !OpenCatalog;
			}}
			class:bg-custom-d-f={!OpenCatalog}
			class="flex pr-[23px] pl-[30px] bg-custom-d-f justify-between items-center pt-[20px] pb-[18px]"
		>
			<button class="text-base font-normal text-custom-gray2"
				>{lang[$page.data.host]['catalogTitile']}</button
			>
			<button class="text-base font-normal text-custom-gray2"
				>{#if OpenCatalog}
					-
				{:else}
					+
				{/if}
			</button>
		</div>
		{#if !OpenCatalog}
			<div class=" pr-[23px] pl-[30px] bg-custom-d-f w-full">
				<div class="border-b-[0.5px] border-custom-gray2" />
			</div>
		{:else}
			<div class=" pr-[23px] pl-[30px] w-full">
				<div class="border-b-[0.5px] border-custom-gray" />
			</div>
		{/if}
		{#if OpenCatalog}
			<div transition:slide class="w-full pl-[57px] bg-custom-dark-bg min-h-[20vh]">
				{#each $page.data.manucategories as item, ind}
					<div class="flex justify-between items-center pr-[27px] pt-[20px] pb-[18px]">
						<button on:click={() => goto('/' + item.slug)} class="text-sm text-custom-gray2"
							>{item[`name${$page.data.host}`]}</button
						>
						<button class="text-sm text-custom-gray2">
							<img width="5" height="12" src={arrow} alt="arrow-right" />
						</button>
					</div>
					{#if ind != $page.data.manucategories.length - 1}
						<div class="pr-[27px]">
							<div class="border-b-[0.5px] border-custom-gray" />
						</div>
					{/if}
				{/each}
			</div>
		{/if}
		<!-- Наша компания -->
		<!-- svelte-ignore a11y-click-events-have-key-events -->
		<!-- svelte-ignore a11y-no-static-element-interactions -->
		<div
			on:click={() => {
				OpenNashCompany = !OpenNashCompany;
			}}
			class:bg-custom-d-f={!OpenNashCompany}
			class="flex pr-[23px] pl-[30px] justify-between items-center pt-[20px] pb-[18px]"
		>
			<button class="text-base font-normal text-custom-gray2"
				>{lang[$page.data.host]['nahcompany']}</button
			>
			<button class="text-base font-normal text-custom-gray2">
				{#if OpenNashCompany}
					-
				{:else}
					+
				{/if}
			</button>
		</div>
		{#if !OpenNashCompany}
			<div class=" pr-[23px] pl-[30px] bg-custom-d-f w-full">
				<div class="border-b-[0.5px] border-custom-gray2" />
			</div>
		{:else}
			<div class=" pr-[23px] pl-[30px] w-full">
				<div class="border-b-[0.5px] border-custom-gray" />
			</div>
		{/if}
		{#if OpenNashCompany}
			<div transition:slide class="w-full pl-[57px] bg-custom-dark-bg min-h-[20vh]">
				{#each nashcompanies as item, ind}
					<div class="flex justify-between items-center pr-[27px] pt-[20px] pb-[18px]">
						<button on:click={() => goto(item.slug)} class="text-sm text-custom-gray2"
							>{item.name}</button
						>
						<button class="text-sm text-custom-gray2">
							<img width="5" height="12" src={arrow} alt="arrow-right" />
						</button>
					</div>
					{#if ind != nashcompanies.length - 1}
						<div class="pr-[27px]">
							<div class="border-b-[0.5px] border-custom-gray" />
						</div>
					{/if}
				{/each}
			</div>
		{/if}

		<!-- СЛЕДИТЕ ЗА НАМИ -->
		<!-- svelte-ignore a11y-click-events-have-key-events -->
		<!-- svelte-ignore a11y-no-static-element-interactions -->
		<div
			on:click={() => {
				OpenSocSety = !OpenSocSety;
			}}
			class:bg-custom-d-f={!OpenSocSety}
			class="flex pr-[23px] pl-[30px] justify-between items-center pt-[20px] pb-[18px]"
		>
			<button class="text-base font-normal text-custom-gray2">{lang[$page.data.host]['see']}</button
			>
			<button class="text-base font-normal text-custom-gray2">
				{#if OpenSocSety}
					-
				{:else}
					+
				{/if}
			</button>
		</div>
		{#if !OpenSocSety}
			<div class=" pr-[23px] pl-[30px] bg-custom-d-f w-full">
				<div class="border-b-[0.5px] border-custom-gray2" />
			</div>
		{:else}
			<div class=" pr-[23px] pl-[30px] w-full">
				<div class="border-b-[0.5px] border-custom-gray" />
			</div>
		{/if}
		{#if OpenSocSety}
			<div transition:slide class="w-full pl-[57px] bg-custom-dark-bg min-h-[20vh]">
				<!-- Insta -->
				<div class="flex justify-between items-center pr-[27px] pt-[20px] pb-[18px]">
					<button class="text-sm text-custom-gray2">
						<a
							class="text-sm font-normal inline-flex text-custom-gray2"
							target="_blank"
							rel="noreferrer"
							href="https://instagram.com/iloveitalianbags?igshid=YmMyMTA2M2Y="
						>
							<img width="15" height="15" src={insta} alt="" />
							<span class="ml-[8px]">Instagram</span></a
						>
					</button>
					<button class="text-sm text-custom-gray2">
						<img width="5" height="12" src={arrow} alt="arrow-right" />
					</button>
				</div>

				<div class="pr-[27px]">
					<div class="border-b-[0.5px] border-custom-gray" />
				</div>

				<!-- VK -->
				<div class="flex justify-between items-center pr-[27px] pt-[20px] pb-[18px]">
					<button class="text-sm text-custom-gray2">
						<a
							class="text-sm font-normal inline-flex text-custom-gray2"
							target="_blank"
							rel="noreferrer"
							href="https://instagram.com/iloveitalianbags?igshid=YmMyMTA2M2Y="
						>
							<img width="15" height="15" src={wk} alt="" />
							<span class="ml-[8px]">Vk</span></a
						>
					</button>
					<button class="text-sm text-custom-gray2">
						<img width="5" height="12" src={arrow} alt="arrow-right" />
					</button>
				</div>

				<div class="pr-[27px]">
					<div class="border-b-[0.5px] border-custom-gray" />
				</div>
				<!-- WP-->
				<div class="flex justify-between items-center pr-[27px] pt-[20px] pb-[18px]">
					<button class="text-sm text-custom-gray2">
						<a
							class="text-sm font-normal inline-flex text-custom-gray2"
							target="_blank"
							rel="noreferrer"
							href="https://instagram.com/iloveitalianbags?igshid=YmMyMTA2M2Y="
						>
							<img width="15" height="15" src={wp} alt="" />
							<span class="ml-[8px]">Whats App</span></a
						>
					</button>
					<button class="text-sm text-custom-gray2">
						<img width="5" height="12" src={arrow} alt="arrow-right" />
					</button>
				</div>
			</div>
		{/if}
		{#if $page.data.host === 'ARM'}
			<p class=" text-white mb-4 pt-[24px] mt-4 pr-[23px] pl-[23px] pb-[24px]">
				<img class="mt-4 mb-4" src="/visa.png" alt="" />
				Բոլոր գործարքներն իրականացվում են բացառապես 3D Secure համակարգի միջոցով: Գործարք կատարող քարտապանի
				քարտի տվյալները պաշտպանված են: Եթե Քարտապանի Քարտի արժույթը չի համապատասխանում գործարքի արժույթի
				հետ, փոխարկումը իրականացվում է համաձայն համապատասխան վճարահաշվարկային համակարգի և Քարտը թողարկող
				Բանկի կողմից սահմանված կանոնների
			</p>
		{/if}
		<div class="pr-[23px] pb-[24px] pt-[24px] pl-[30px] bg-custom-d-f w-full">
			<span class="text-custom-gray2 text-sm"
				>Iloveitalianbags. {lang[$page.data.host]['title']}(c) 2021- {new Date().getFullYear()}</span
			>
		</div>
	</div>
</div>
